<template>
    <div id="indication-time-video-frame">
        {{time}} <br> <br>
        <button @click="debugButton">Pause/Play</button>
    </div>
</template>
<script>
    import action from "@/assets/audio/ok.wav";
    export default {
        name: 'Debug',
        props: {
            time: {}
        },
        methods: {
            debugButton() {
                let sound = new Audio(action)
                sound.play()
                if (this.$parent.video.paused === true) {
                    this.$parent.video.play()
                    this.$parent.$refs.audioFile.play()
                } else {
                    this.$parent.video.pause()
                    this.$parent.$refs.audioFile.pause()
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    #indication-time-video-frame {
        position: absolute;
        text-align: center;
        top: 10%;
        left: 10%;
        background-color: rgba(0, 0, 0, 0.51);
        color: #fff;
        padding: 30px 50px;
        box-sizing: border-box;
        padding: 1% 3%;
    }

</style>
